export default __webpack_public_path__ + "static/media/Galaxy_17.78acbdc5.png";